// A visit's confirmation by text (BL-016): the customer replied C to the reminder for its time.
// The job sheet says when; the board's chip says it shorter. A move clears it (the server's rule).

import { dateText, timeText } from '@flowology/kernel';

export interface VisitConfirmation {
  at: string;
  by: 'text';
}

/** "Confirmed by text at 6:12 p.m., Oct 20", or null when it isn't confirmed. */
export function confirmationWords(c: VisitConfirmation | null | undefined, timeZone: string): string | null {
  if (!c) return null;
  return `Confirmed by text at ${timeText(c.at, timeZone)}, ${dateText(c.at, timeZone, { year: false })}`;
}
